import React, { PureComponent } from 'react';
import { read } from '../utils/request';
import type { Office, LegalBasisType } from './shared/types';
import { MultipleRulesContext } from './multiple_rules/context';
import DataCollectionRules from './data_collection_rules';
import DataRetentionRules from './data_retention_rules';
import LegalBasis from './legal_basis';

type Props = {
  all_offices_path: string;
  collection_rules_path: string;
  retention_rules_path: string;
  email_template_path: string;
  display_manual_email_entry: boolean;
  legal_basis: LegalBasisType;
  single_purpose_consent_enabled: boolean;
  processing_legal_basis: LegalBasisType;
  retention_legal_basis: LegalBasisType;
  show_data_collection_rules: boolean;
};

type State = {
  offices: Array<Office>;
  displayManualEmailEntry: boolean;
};

export default class MultipleRules extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      offices: [],
      displayManualEmailEntry: this.props.display_manual_email_entry,
    };
  }

  async componentDidMount(): Promise<void> {
    const response = await read(this.props.all_offices_path);
    this.setState({ offices: response.data.results });
  }

  render() {
    const {
      collection_rules_path,
      retention_rules_path,
      email_template_path,
      single_purpose_consent_enabled,
      processing_legal_basis,
      retention_legal_basis,
      legal_basis,
      show_data_collection_rules,
    } = this.props;

    return (
      <MultipleRulesContext.Provider value={this.state}>
        <LegalBasis
          legalBasis={legal_basis}
          singlePurposeConsentEnabled={single_purpose_consent_enabled}
          processingLegalBasis={processing_legal_basis}
          retentionLegalBasis={retention_legal_basis}
          emailTemplatePath={email_template_path}
        />
        <DataRetentionRules rules_path={retention_rules_path} />
        {show_data_collection_rules && (
          <DataCollectionRules
            rulesPath={collection_rules_path}
            emailTemplatePath={email_template_path}
          />
        )}
      </MultipleRulesContext.Provider>
    );
  }
}
